import React from 'react';
import FormDataFileUpload from './FormDataFileUpload';
import { API_URL } from 'config';
import { Helmet } from 'react-helmet';
import useUserIsSuper from 'util/hooks/useUserIsSuper';

type Type = 'process' | 'form' | 'decision-table';
const getRoute = (type: Type) => {
    switch (type) {
        case 'process':
            return 'process-definition';
        case 'form':
            return 'form-definition';
        case 'decision-table':
            return 'dmn-definition';
    }
};

const getLabel = (type: Type) => {
    switch (type) {
        case 'process':
            return 'Process Definition';
        case 'form':
            return 'Form Definition';
        case 'decision-table':
            return 'Decision Table Definition';
    }
};
export default () => {
    const userIsSuper = useUserIsSuper();
    const [key, setKey] = React.useState<string | null>(null);
    const [version, setVersion] = React.useState<string | null>(null);
    const [type, setType] = React.useState<Type>('process');
    if (!userIsSuper) {
        return <div>You do not have access to this page.</div>;
    }
    return (
        <div style={{ padding: '1em' }}>
            <Helmet>
                <title>Update Definitions</title>
            </Helmet>
            <FormDataFileUpload
                url={`${API_URL}bpm/${getRoute(type)}/${key}/update?version=${version}`}
                render={({ onChange, onFormSubmit, status, fileStaged }) => {
                    return (
                        <div>
                            <label htmlFor="type">Upload Type</label>&nbsp;
                            <select id="type" value={type} onChange={e => setType(e.target.value as Type)}>
                                <option value={'process'}>Process Definition</option>
                                <option value={'form'}>Form Definition</option>
                                <option value={'decision-table'}>Decision Table Definition</option>
                            </select>
                            <form onSubmit={onFormSubmit}>
                                <br />
                                <label htmlFor="upload">{getLabel(type)}File</label>&nbsp;
                                <input id="upload" disabled={status.isPending()} type="file" onChange={onChange} />
                                <br />
                                <br />
                                <label htmlFor="key">{getLabel(type)} Key</label>&nbsp;
                                <input
                                    disabled={status.isPending()}
                                    type="text"
                                    onChange={e => setKey(e.target.value)}
                                />
                                <br />
                                <br />
                                <label htmlFor="version">
                                    Enter {getLabel(type)} version or "latest" to choose latest
                                </label>
                                &nbsp;
                                <input
                                    disabled={status.isPending()}
                                    type="text"
                                    onChange={e => setVersion(e.target.value)}
                                />
                                <br />
                                <br />
                                <button disabled={status.isPending() || !fileStaged || !key || !version} type="submit">
                                    Upload
                                </button>
                                <p aria-live="polite" aria-atomic="true">
                                    {status.isFailure() ? (
                                        <React.Fragment>
                                            Upload Failed:
                                            <pre>{status.error.message}</pre>
                                        </React.Fragment>
                                    ) : status.isSuccess() ? (
                                        'Upload successful'
                                    ) : status.isPending() ? (
                                        'Loading...'
                                    ) : null}
                                </p>
                            </form>
                        </div>
                    );
                }}
            />
        </div>
    );
};
